/**
 * Elarune Co. - acordeon de preguntas frecuentes.
 *
 * Envuelve elementos <details> nativos: sin JavaScript siguen abriendo y
 * cerrando, y los lectores de pantalla ya los anuncian como desplegables.
 * Lo unico que anade el componente es cerrar el resto al abrir uno, que es
 * comportamiento del diseno, no accesibilidad.
 *
 * La altura se anima con una transicion sobre grid-template-rows, que no
 * obliga a medir el contenido ni provoca saltos al redimensionar.
 */

class ElaruneAccordion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.single !== 'true') return;

    this.addEventListener('toggle', this.onToggle, true);
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.onToggle, true);
  }

  onToggle = (event) => {
    const opened = event.target;
    if (!opened.open || opened.tagName !== 'DETAILS') return;

    this.querySelectorAll('details[open]').forEach((item) => {
      if (item !== opened) item.open = false;
    });
  };
}

if (!customElements.get('elarune-accordion')) {
  customElements.define('elarune-accordion', ElaruneAccordion);
}
